import React, { useRef, useEffect, useState } from 'react';
import {
  SDrawerOrModal,
} from 'shj-components'
import { Form, TreeSelect, Radio, Select, Button, Input, Space, message } from 'antd';
import { useUpdateEffect } from 'ahooks'
import { ExclamationCircleOutlined } from '@ant-design/icons'

export default function AddConfigModal ({
  editId = '',
  editData = {},
  openModal = false,
  setOpenModal = (a) => ({}),
  specsArgList = [],
  specsArgMap = {},
  spaceList = [],
  confirm = (a) => ({}),
  editSpaceSpecs = (a, b) => ({}),
})  {
  const [ form ] = Form.useForm();

  const [serviceLoading, setServiceLoading] = useState(false);
  const [specsValues, setSpecsValues] = useState([]);
  const [generalList, setGeneralList] = useState([]);
  const [selectArgCode, setSelectArgCode] = useState('');

  const spaceSpecParamId = Form.useWatch('spaceSpecParamId', form);
  const includeValueIds = Form.useWatch('includeValueIds', form);

  useUpdateEffect(() => {
    const selectItem = specsArgList?.filter((item: any) => item.id === spaceSpecParamId)?.[0];
    setSelectArgCode(selectItem?.argCode);
    if (specsArgMap?.[spaceSpecParamId]) {
      setSpecsValues(specsArgMap?.[spaceSpecParamId])
    }
  }, [ spaceSpecParamId ])

  useUpdateEffect(() => {
    // 标配参数值选项等于参数包含值选的值
    const list = specsArgMap?.[spaceSpecParamId]?.filter(item => includeValueIds.includes(item.id)) || [];
    const standardValueId = form.getFieldValue('standardValueId');
    const generalIndex = list?.findIndex(item => item.id === standardValueId);
    if (generalIndex === -1) {
      form.setFieldValue('standardValueId', '');
    }
    setGeneralList(list);
  }, [includeValueIds])

  useEffect(() => {
    if (editId) {
      form.setFieldsValue(editData);
    }
  }, [editId])

  const handleChangeSpecParam = () => {
    form.setFieldValue('includeValueIds', []);
  }

  const onSubmitService = () => {
    form.validateFields().then((value: any) => {
      if (editId) {
        editSpaceSpecs(value, editId)
      } else {
        confirm(value);
      }
    })
  }

  return (
    <div>
      <SDrawerOrModal
        title={ editId ? '编辑配置' : '添加配置'}
        mode="modal"
        open={openModal}
        onCancel={() => setOpenModal(false)}
        onOk={onSubmitService}
        loading={serviceLoading}
        width="500px"
      >
        <Form form={form} layout='vertical'>
          {
            !editId ? (
              <Form.Item
                name='spaces'
                label='空间标签'
                rules={[{
                  required: true,
                }]}
                labelCol={{
                  span: 6,
                }}
              >
                <Select
                  showSearch
                  optionFilterProp={'name'}
                  mode={'multiple'}
                  options={spaceList}
                  fieldNames={{ label: 'name', value: 'code' }}
                  placeholder='请选择'
                ></Select>
              </Form.Item>
            ) : null
          }
          <Form.Item
            name='spaceSpecParamId'
            label='空间规格参数'
            rules={[{
              required: true,
            }]}
            labelCol={{
              span: 6,
            }}
          >
            <Select
              showSearch
              optionFilterProp={'argName'}
              onChange={handleChangeSpecParam}
              options={specsArgList}
              fieldNames={{ label: 'argName', value: 'id' }}
              placeholder='请选择'
            ></Select>
          </Form.Item>
          <Form.Item
            name='includeValueIds'
            label='参数包含值'
            rules={[{
              required: true,
            }]}
            labelCol={{
              span: 6,
            }}
          >
            <Select placeholder='请选择' mode={'multiple'} options={specsValues} fieldNames={{ label: 'argValue', value: 'id' }}></Select>
          </Form.Item>
          {
            selectArgCode === 'TOILET_LEVEL' ? (
              <Form.Item
                name='standardValueId'
                label='标配参数值'
                rules={[{
                  required: true,
                }]}
                labelCol={{
                  span: 6,
                }}
              >
                <Select placeholder='请选择' options={generalList} fieldNames={{ label: 'argValue', value: 'id' }}></Select>
              </Form.Item>
            ) : null
          }
        </Form>
      </SDrawerOrModal>
    </div>
  )
}
